import { localApi } from '../utils/axios';

// 获取学生列表
export const getStudents = async (params = {}) => {
  try {
    const response = await localApi.get('/students', { params });
    return response.data.data || []; // 确保返回数组
  } catch (error) {
    console.error('获取学生列表失败:', error);
    throw error;
  }
};

// 添加学生
export const addStudent = async (studentData) => {
  try {
    // 添加调试日志
    console.log('发送学生数据到 API:', studentData);
    
    // 确保数据格式正确
    const formattedData = {
      ...studentData,
      // 确保布尔值正确传递
      is_active: studentData.is_active === '1' || studentData.is_active === true,
      // 确保角色字段存在
      role: studentData.role || 'student',
      // 将邮箱字段作为用户名备用
      username: studentData.username || studentData.email
    };
    
    // 使用注册用户的 API 端点，因为学生也是用户
    const response = await localApi.post('/auth/register', formattedData);
    console.log('API 响应:', response.data);
    return response.data.data || response.data;
  } catch (error) {
    console.error('添加学生失败:', error);
    // 提供更详细的错误信息
    if (error.response?.data?.message) {
      console.error('错误详情:', error.response.data.message);
    } else if (error.response?.data?.error) {
      console.error('错误详情:', error.response.data.error);
    }
    throw error;
  }
};

// 更新学生信息
export const updateStudent = async (id, studentData) => {
  try {
    const response = await localApi.put(`/teacher/students/${id}`, studentData);
    return response.data.data;
  } catch (error) {
    console.error('更新学生信息失败:', error);
    throw error;
  }
};

// 删除学生
export const deleteStudent = async (id) => {
  try {
    const response = await localApi.delete(`/students/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('删除学生失败:', error);
    throw error;
  }
};

// 获取单个学生详情
export const getStudentById = async (id) => {
  try {
    const response = await localApi.get(`/students/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('获取学生详情失败:', error);
    throw error;
  }
};

// 批量导入学生
export const importStudents = async (studentList) => {
  try {
    const response = await localApi.post('/students/batch', { students: studentList });
    return response.data.data;
  } catch (error) {
    console.error('批量导入学生失败:', error);
    throw error;
  }
};

// 重置学生密码
export const resetStudentPassword = async (id) => {
  try {
    const response = await localApi.post(`/students/${id}/reset-password`);
    return response.data.data;
  } catch (error) {
    console.error('重置学生密码失败:', error);
    throw error;
  }
}; 